const KIDS_TYPES = {
  nasheed: 'KIDS_NASHEED',
  calm_sound: 'KIDS_CALM_SOUND',
  story: 'KIDS_NASHEED',
  game: 'KIDS_GAME',
  book: 'KIDS_BOOK'
};

function isKidsAudience(entity) {
  const a = (entity?.audience ?? '').toString().toLowerCase();
  return a === 'kids' || a === 'kid';
}

function pickLanguageId(obj) {
  if (!obj) return null;
  return obj.language_id ?? obj.language?.id ?? obj.languageId ?? obj.attributes?.language_id ?? obj.attributes?.languageId ?? obj.attributes?.language?.id ?? null;
}

export function getContentLanguageId(content, fallbackContent = null) {
  const id = pickLanguageId(content);
  if (id != null) return id;
  if (!fallbackContent) return null;
  return pickLanguageId(fallbackContent);
}

export function getContentFeedType(entity, context = '') {
  const ctx = (context || '').toLowerCase();
  if (ctx === 'game') return 'KIDS_GAME';
  if (ctx === 'hadith') return 'HADITH';
  if (ctx === 'book') {
    return isKidsAudience(entity) ? 'KIDS_BOOK' : 'BOOK';
  }
  if (ctx === 'page') {
    const bookAudience = entity?.book_audience ?? entity?.book?.audience;
    const kids = (String(bookAudience ?? '').toLowerCase() === 'kids');
    return kids ? 'KIDS_BOOK' : 'PAGE';
  }
  if (ctx === 'podcast' || ctx === 'audio') {
    if (!isKidsAudience(entity)) return 'PODCAST';
    const t = (entity?.type ?? entity?.content_type ?? 'nasheed').toString().toLowerCase().replace(/-/g, '_');
    return KIDS_TYPES[t] ?? KIDS_TYPES.nasheed;
  }
  if (ctx === 'page_content' || ctx === 'pagecontent') {
    const t = (entity?.type ?? '').toString().toLowerCase().replace(/-/g, '_');
    return t === 'quran_verse' ? 'AYAH' : 'PAGE';
  }
  return 'PODCAST';
}

const DB_TITLE_SAFE_MAX = 250;

export function normalizeContentFeedTitle(raw, type) {
  const t = String(raw ?? '')
    .replace(/\r\n/g, ' ')
    .replace(/\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const base = t.length ? t : 'Untitled';
  const upper = String(type ?? '').toUpperCase();
  const maxTotal = upper === 'HADITH' ? 30 : DB_TITLE_SAFE_MAX;
  if (base.length <= maxTotal) return base;
  const ellipsis = '...';
  const keep = maxTotal - ellipsis.length;
  if (keep <= 0) return ellipsis.slice(0, maxTotal);
  return base.slice(0, keep) + ellipsis;
}

export const FEED_TYPE_OPTIONS = [
  { value: '', label: 'All types' },
  { value: 'PODCAST', label: 'Podcast' },
  { value: 'HADITH', label: 'Hadith' },
  { value: 'AYAH', label: "Kur'anski ajet" },
  { value: 'VERSE', label: "Kur'anski ajet" },
  { value: 'BOOK', label: 'Book' },
  { value: 'PAGE', label: 'Page' },
  { value: 'KIDS_NASHEED', label: 'Kids Nasheed' },
  { value: 'KIDS_CALM_SOUND', label: 'Kids Calm Sound' },
  { value: 'KIDS_GAME', label: 'Kids Game' },
  { value: 'KIDS_BOOK', label: 'Kids Book' }
];

/** The app's Kids section shows these; a calm sound has no card there, so readers never see it. */
export const KIDS_FEED_TYPES = ['KIDS_BOOK', 'KIDS_GAME', 'KIDS_NASHEED', 'KIDS_CALM_SOUND'];
export const TYPES_NOT_IN_APP = ['KIDS_CALM_SOUND'];

/** A post as the phone card reads it, from a feed row. */
export function phonePostFromFeed(feed) {
  const type = feed?.type ?? '';
  const verse = feed?.pageContents?.[0];
  if (type === 'VERSE') {
    const verses = (feed.pageContents ?? []).map((block) => ({ id: block.id, arabic: block.content?.arabic, text: block.content?.translation, reference: block.pageTitle }));
    return { kind: 'ayah', arabic: verse?.content?.arabic, text: verse?.content?.translation, reference: verse?.pageTitle, verses };
  }
  if (type === 'HADITH') {
    const hadith = feed?.hadiths?.[0];
    return { kind: 'hadith', text: hadith?.text ?? feed?.title, source: hadith?.books?.[0]?.name };
  }
  if (type === 'BOOK' || type === 'KIDS_BOOK') {
    const book = feed?.books?.[0];
    return { kind: 'book', title: book?.name ?? feed?.title, text: book?.description, image: book?.coverImage?.url, kids: type === 'KIDS_BOOK' };
  }
  if (type === 'PODCAST') {
    const podcast = feed?.podcasts?.[0];
    return { kind: 'podcast', title: podcast?.title ?? feed?.title, image: podcast?.image_url, source: podcast?.duration };
  }
  if (type === 'PAGE') {
    return { kind: 'page', pages: (feed?.pages ?? []).map((page) => ({ id: page.id, title: page.title, text: page.pageContents?.[0]?.content?.value })) };
  }
  if (type === 'KIDS_GAME') {
    const game = feed?.games?.[0];
    return { kind: 'game', title: game?.name ?? feed?.title, text: game?.description, image: game?.cover?.url, kids: true };
  }
  const audio = feed?.audioContents?.[0];
  return { kind: 'audio', title: audio?.title ?? feed?.title, text: audio?.description, image: audio?.cover?.url, kids: true };
}

export const FEED_STUDIO_KINDS = [
  { value: 'ayah', label: "Qur'an" },
  { value: 'hadith', label: 'Hadith' },
  { value: 'tafsir', label: 'Tafsir' },
  { value: 'opinion', label: 'Scholars' },
  { value: 'page', label: 'Book pages' },
  { value: 'book', label: 'Books' },
  { value: 'podcast', label: 'Lectures' },
  { value: 'audio', label: 'Audio' },
  { value: 'game', label: 'Games' }
];
